module.exports = __webpack_public_path__ + "img/pr-1.d2430171.png";